import { createRouter, createWebHistory } from 'vue-router'
import type { RouteLocationNormalized, NavigationGuardNext } from 'vue-router'
import HomeView from '@/views/HomeView.vue'
import authService from '@/services/authService'

/**
 * Navigation guard per proteggere le rotte che richiedono autenticazione
 * Per usarlo, aggiungi meta: { requiresAuth: true } alla rotta
 */
const authGuard = (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) => {
  const isAuthenticated = authService.isAuthenticated()

  // Se l'utente è già loggato e prova ad accedere alla pagina di login, reindirizza alla home
  if (to.name === 'login' && isAuthenticated) {
    next({ name: 'home' })
    return
  }

  // Se la rotta richiede autenticazione e l'utente non è loggato, reindirizza al login
  if (to.meta.requiresAuth && !isAuthenticated) {
    next({
      name: 'login',
      query: { redirect: to.fullPath }
    })
    return
  }

  next()
}

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/LoginView.vue'),
      meta: { requiresAuth: false }
    },
    {
      path: '/',
      name: 'home',
      component: HomeView,
      meta: { requiresAuth: true }
    },
    {
      path: '/category/:categoryName',
      name: 'category',
      component: () => import('@/views/CategoryView.vue'),
      props: true,
      meta: { requiresAuth: true }
    },
    {
      path: '/category/:categoryName/site/:siteName',
      name: 'site-detail',
      component: () => import('@/views/SiteDetailView.vue'),
      props: true,
      meta: { requiresAuth: true }
    },
    {
      path: '/health',
      name: 'health',
      component: () => import('@/views/HealthView.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/:pathMatch(.*)*',
      redirect: '/'
    }
  ]
})

// Applica il guard globale
router.beforeEach(authGuard)

export default router